import { UserModel } from "../app/modules/auth/models/UserModel";
import { PROGRESS_TYPE_TANRISE } from "../constant/General";
import { Pipeline } from "../interfaces/Pipeline";
import { SettingMultiPipelines } from "../interfaces/Settings";
import { CustomeStoreCompanyIdProps, CustomStoreRoleIdProps, keyCustomfieldProps } from "../stores/CustomeStore";

// General
export function isDisabledPriceProduct(user: UserModel, roleId: CustomStoreRoleIdProps) {
    if (
        roleId.johnson.salesDirector === user.data.role_id ||
        roleId.johnson.sales === user.data.role_id
    )
        return true
}

export function isActionUpdatePipeline(user: UserModel, pipeline: Pipeline, merchantId: string) {
    return (user.data.is_superadmin || user.data.permission_pipeline_update !== 'NONE') && !pipeline?.has_pending_log && !merchantId
}
export function isActionDeletePipeline(user: UserModel, pipeline: Pipeline, merchantId: string) {
    return (user.data.is_superadmin || user.data.permission_pipeline_delete !== 'NONE') && !pipeline?.has_pending_log && !merchantId
}
export function isActionLogPipeline(user: UserModel) {
    return (user.data.is_superadmin || user.data.permission_pipeline_log_read !== 'NONE')
}

export function isActionAddLogPipeline(user: UserModel, row: Pipeline, merchantId: string, selectMultiPipeline: SettingMultiPipelines, companyId: CustomeStoreCompanyIdProps) {
    const { is_superadmin, permission_pipeline_log_create, company_id } = user.data;
    const isAuthorized = is_superadmin || permission_pipeline_log_create !== 'NONE';
    const isLeadProgressTerm1 = row?.lead_progress_name.toLocaleLowerCase() === "termin 1";
    const isCompanyMatch = company_id === companyId.uec || company_id === companyId.looyalIT;
    const isNotMerchant = !merchantId;
    const isLeadInProgress = row?.lead_progress_progress_type !== "FAIL" && row?.lead_progress_progress_type !== "SUCCESS";
    const isPendingLog = row?.has_pending_log

    if (selectMultiPipeline.isInfiniteLog || isPendingLog) {
        if (selectMultiPipeline.isAllowAfterFailedLog && row?.lead_progress_progress_type === "FAIL") return true
        if (selectMultiPipeline.isAllowAfterSuccessLog && row?.lead_progress_progress_type === "SUCCESS") return true
    } else {
        if (selectMultiPipeline.isAllowAfterFailedLog && row?.lead_progress_progress_type === "FAIL") return true
        if (selectMultiPipeline.isAllowAfterSuccessLog && row?.lead_progress_progress_type === "SUCCESS") return true
    }

    if (isAuthorized && isLeadProgressTerm1 && isCompanyMatch && isNotMerchant) {
        return true;
    }

    if (isAuthorized && isLeadInProgress && isNotMerchant) {
        return true;
    }

    return false;
}

export function isActionDetailProductPipeline(merchantId: string) {
    return !merchantId
}
export function isActionActivitiyPipeline(user: UserModel, companyId: CustomeStoreCompanyIdProps, roleId: CustomStoreRoleIdProps, merchantId: string) {
    return user.data.company_id === companyId.juraganMaterial && (user.data.is_superadmin || user.data.role_id === roleId.juraganMaterial.salesProductManager || user.data.role_id === roleId.juraganMaterial.scm) && !merchantId
}

export function isActionDetailTerminPipeline(row: Pipeline) {
    return Array.isArray(row?.paymentTermins) && row.paymentTermins.length > 0 && row.paymentTermins[0]?.nominal! > 0
}

export function isCustomCompanyPipeline(companyTarget: string, user: UserModel, companyId: CustomeStoreCompanyIdProps, thisPipeline: SettingMultiPipelines | string, merchantId?: string): boolean {
    if (companyTarget === 'wolacom' && user.data.company_id === companyId.wolacom) {
        const pipelineId = typeof thisPipeline === 'string' ? thisPipeline : thisPipeline.id
        const customMerchantAddressDatabaseIds = process.env.NODE_ENV === 'development' ? ['505144a4-bcc7-4b87-b013-82fe1d2a1f3e'] /* Fenrir-08 */ : ['cee9bd69-97f8-47b2-b965-7f2d451e170e']
        if (customMerchantAddressDatabaseIds.includes(pipelineId)) {
            return true
        }
    } else if (companyTarget === 'elgisa' && user.data.company_id === companyId.elgisa) {
        return true
    }
    return false
}

export const checkIsCompanyElgisa = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.elgisa) {
        return true
    }
}

export const checkIsCompanyEsb = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.esb) {
        return true
    }
}

// PS Enterprise
export function showSerial(lead: Pipeline, keyCustomfield: keyCustomfieldProps) {
    if (lead.custom_fields[keyCustomfield.serial.enterpriseService]) {
        return '- ' + (lead.custom_fields[keyCustomfield.serial.enterpriseService] as string[]).join('')
    } else if (lead.custom_fields[keyCustomfield.serial.enterpriseSales]) {
        return '- ' + (lead.custom_fields[keyCustomfield.serial.enterpriseSales] as string[]).join('')
    } else return ''
}

export const checkIsCompanyMeratus = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.meratus) {
        return true
    } else {
        return false
    }
}

export const checkIsCompanyHarriette = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.harriette || user?.data?.company_id === companyId.looyalIT) {
        return true
    } else {
        return false
    }
}

export const checkIsCompanyTanrise = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.tanrise) {
        return true
    } else {
        return false
    }
}

export const checkIsCompanyTkd = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.tkd) {
        return true
    } else {
        return false
    }
}

export const checkIsNewProgress = (progressName: string) => {
    return progressName === 'NEW' || progressName === 'New Data' || progressName === 'Data Baru'
}

export const checkIsProgressUTMorUTJTanrise = (progressId: string, companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if ((progressId === PROGRESS_TYPE_TANRISE.UTM || progressId === PROGRESS_TYPE_TANRISE.UTJ) && checkIsCompanyTanrise(companyId, user)) {
        return true
    } else {
        return false
    }
}

export const checkIsCompanyVaporesia = (companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    if (user?.data?.company_id === companyId.vaporesia) {
        return true
    } else {
        return false
    }
}

export const checkAccessProgressAddLog = (row: Pipeline, selectMultiPipeline: SettingMultiPipelines) => {
    if (selectMultiPipeline.isAllowAfterFailedLog && row?.lead_progress_progress_type === "FAIL") return true
    if (selectMultiPipeline.isAllowAfterSuccessLog && row?.lead_progress_progress_type === "SUCCESS") return true
    if (selectMultiPipeline.isInfiniteLog || row?.has_pending_log) return true
    return false
}

// UEC
// export function isActionAddLogPipelineUec(user: UserModel, row: Pipeline, merchantId: string, companyId: CustomeStoreCompanyIdProps) {
//     return (user.data.is_superadmin || user.data.permission_pipeline_log_create !== 'NONE') && (row?.lead_progress_name)?.toLocaleLowerCase() === "termin 1" && (user.data.company_id === companyId.uec || user.data.company_id === companyId.looyalIT) && !merchantId
// }
